export default __webpack_public_path__ + "static/meta-555268329a57e5c30b289164c31ec0af.svg";